"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionListItem = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _utils = require("../../ViewAction/utils");

var _typography = require("../../../../utils/typography");

var _utils2 = require("../../utils");

var _locale = require("../../../../context/locale");

var _dates = require("../../../../utils/dates");

const Wrapper = _styledComponents.default.li`
  padding: ${_blocks.spacing.default} ${_blocks.spacing.loose};
  border-bottom: 1px solid ${_blocks.palette.neutral3};
  background-color: ${props => props.isSelected ? _blocks.palette.neutral2 : 'none'};

  &:hover {
    cursor: pointer;
    background-color: ${_blocks.palette.neutral1};
  }
`;
const SubduedBodySmall = (0, _styledComponents.default)(_blocks.BodySmall)`
  color: ${_blocks.color.theme.typography.subdued};
`;
const StyledControlGroup = (0, _styledComponents.default)(_blocks.ControlGroup)`
  margin-bottom: ${_blocks.spacing.tight};
`;

const ActionListItem = ({
  action,
  isSelected,
  onSelect
}) => {
  const {
    key,
    summary,
    description,
    bonfire_status,
    priority,
    created,
    updated
  } = action;
  const {
    locale
  } = (0, _locale.useLocale)();
  const createdDateString = (0, _dates.localizedFormat)(new Date(created), 'LLL d', locale);
  const updatedDateString = updated ? (0, _dates.localizedFormatDistanceStrict)(new Date(updated), new Date(), locale) : null;
  return /*#__PURE__*/React.createElement(Wrapper, {
    onClick: () => onSelect(action),
    isSelected: isSelected
  }, /*#__PURE__*/React.createElement(_blocks.Body, {
    style: {
      marginBottom: _blocks.spacing.extraTight
    }
  }, /*#__PURE__*/React.createElement("strong", null, `#${(0, _utils.stripProjectPrefix)(key)} ${summary}`)), description && /*#__PURE__*/React.createElement(SubduedBodySmall, {
    style: {
      marginBottom: _blocks.spacing.tight
    }
  }, (0, _typography.trimWithEllipsis)(description)), /*#__PURE__*/React.createElement(StyledControlGroup, {
    extraTight: true
  }, bonfire_status !== undefined && /*#__PURE__*/React.createElement(_blocks.Chip, {
    size: "thin",
    type: "priority",
    appearance: "solid",
    priority: _utils2.statusMap[bonfire_status]
  }, bonfire_status), priority !== undefined && /*#__PURE__*/React.createElement(_blocks.Chip, {
    size: "thin",
    type: "priority",
    appearance: "accent",
    priority: _utils2.priorityMap[priority]
  }, priority)), /*#__PURE__*/React.createElement(SubduedBodySmall, null, `Created ${createdDateString}`, '  ', "\u2022", '  ', updatedDateString && `Updated ${updatedDateString}`));
};

exports.ActionListItem = ActionListItem;